
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import MobileBottomNav from '../../components/MobileBottomNav';

const API_BASE = process.env.REACT_APP_API_BASE || '/.netlify/functions/api';

const STATUS_META = {
  open:      { label: 'مفتوح',         color: '#f87171', bg: 'rgba(248,113,113,0.12)', border: 'rgba(248,113,113,0.35)' },
  in_review: { label: 'قيد المراجعة',  color: '#fbbf24', bg: 'rgba(251,191,36,0.12)',  border: 'rgba(251,191,36,0.35)'  },
  resolved:  { label: 'مغلق',          color: '#34d399', bg: 'rgba(52,211,153,0.12)',   border: 'rgba(52,211,153,0.35)'  },
};

const SEVERITY_META = {
  high:   { label: 'عالي',    color: '#f87171', bg: 'rgba(248,113,113,0.1)',  border: 'rgba(248,113,113,0.3)'  },
  medium: { label: 'متوسط',   color: '#fbbf24', bg: 'rgba(251,191,36,0.1)',   border: 'rgba(251,191,36,0.3)'   },
  low:    { label: 'منخفض',   color: '#60a5fa', bg: 'rgba(96,165,250,0.1)',   border: 'rgba(96,165,250,0.3)'   },
};

const CATEGORY_LABEL = { lecturer: 'محاضر', course: 'مقرر', other: 'أخرى' };


const IconFolder  = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M2 6a2 2 0 012-2h5l2 2h9a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/></svg>;
const IconAlert   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7"/><path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>;
const IconClock   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7"/><path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconCheck   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.7"/><path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconTrash   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconEye     = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" stroke="currentColor" strokeWidth="1.7"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.7"/></svg>;
const IconPen     = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconRefresh = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M1 20v-6h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconSearch  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.8"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>;
const IconUser    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.7"/></svg>;
const IconMail    = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.7"/><path d="M2 8l10 7 10-7" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/></svg>;
const IconFlag    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M4 4.5V21M4 4.5C4 4.5 7 3 10 3c3 0 5 2 8 2 1.5 0 3-.5 3-.5v10s-1.5.5-3 .5c-3 0-5-2-8-2s-6 1.5-6 1.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconClose   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;


function fmtDate(iso) {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('ar-SA', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(iso));
  } catch { return iso; }
}




const ReportsPage = () => {
  const navigate = useNavigate();
  const LIMIT = 5000;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile]           = useState(false);
  const [isTablet, setIsTablet]           = useState(false);

  const [activeFilter, setActiveFilter] = useState('lecturer');
  const [statusFilter, setStatusFilter] = useState('all');
  const [searchQuery,  setSearchQuery]  = useState('');
  const [sortBy,       setSortBy]       = useState('newest');

  const [reports,  setReports]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  const [selectedReport, setSelectedReport] = useState(null);
  const [deleteTarget,   setDeleteTarget]   = useState(null);
  const [deleteLoading,  setDeleteLoading]  = useState(false);

  const [actionReport, setActionReport] = useState(null);
  const [actionStatus, setActionStatus] = useState('');
  const [actionNote,   setActionNote]   = useState('');
  const [actionSaving, setActionSaving] = useState(false);
  const [actionError,  setActionError]  = useState('');

  const mountedRef = useRef(true);
  useEffect(() => { mountedRef.current = true; return () => { mountedRef.current = false; }; }, []);

  useEffect(() => {
    const onResize = () => { const w = window.innerWidth; setIsMobile(w < 768); setIsTablet(w >= 768 && w < 1024); };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const buildHeaders = useCallback(() => {
    let csrf = '';
    try { const m = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/); if (m) csrf = decodeURIComponent(m[1]); } catch {}
    const h = { 'Content-Type': 'application/json' };
    if (csrf) h['X-XSRF-TOKEN'] = csrf;
    return h;
  }, []);

  const fetchReports = useCallback(async () => {
    setLoading(true);
    setErrorMsg('');
    const ctrl = new AbortController();
    try {
      const resp = await fetch(`${API_BASE}/admin/reports?limit=${LIMIT}`, { method: 'GET', headers: buildHeaders(), credentials: 'include', signal: ctrl.signal });
      if (!resp.ok) {
        const code = resp.status;
        let reason = '';
        try { const j = await resp.json(); reason = j?.error || j?.reason || ''; } catch {}
        if (code === 401) throw new Error('غير مصرح: يجب تسجيل الدخول بحساب إداري.');
        if (code === 403) throw new Error('ليس لديك صلاحية لعرض البلاغات.');
        throw new Error(`خطأ ${code}${reason ? ` — ${reason}` : ''}`);
      }
      const data = await resp.json();
      const items = Array.isArray(data) ? data : (data?.items ?? data?.reports ?? []);
      if (mountedRef.current) setReports([...items].sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || '')));
    } catch (err) {
      if (err?.name !== 'AbortError' && mountedRef.current) {
        setErrorMsg(err?.message || 'فشل تحميل البلاغات.');
        setReports([]);
      }
    } finally {
      if (mountedRef.current) setLoading(false);
    }
    return () => ctrl.abort();
  }, [buildHeaders]);

  useEffect(() => { fetchReports(); }, [fetchReports]);


  const stats = useMemo(() => ({
    total:    reports.length,
    open:     reports.filter(r => r.status === 'open').length,
    inReview: reports.filter(r => r.status === 'in_review').length,
    resolved: reports.filter(r => r.status === 'resolved').length,
  }), [reports]);

  const countsByCategory = useMemo(() => ({
    lecturer: reports.filter(r => r.category === 'lecturer').length,
    course:   reports.filter(r => r.category === 'course').length,
    other:    reports.filter(r => r.category === 'other').length,
  }), [reports]);

  const filteredReports = useMemo(() => {
    let list = reports.filter(r => r.category === activeFilter);
    if (statusFilter !== 'all') list = list.filter(r => r.status === statusFilter);
    if (searchQuery.trim()) {
      const q = searchQuery.trim().toLowerCase();
      list = list.filter(r => [r.reporterName, r.reporterEmail, r.targetName, r.title, r.description, r.id].join(' ').toLowerCase().includes(q));
    }
    const sevOrder = { high: 3, medium: 2, low: 1 };
    return [...list].sort((a, b) => {
      if (sortBy === 'oldest')        return new Date(a.createdAt) - new Date(b.createdAt);
      if (sortBy === 'severity_high') return (sevOrder[b.severity] || 0) - (sevOrder[a.severity] || 0);
      if (sortBy === 'severity_low')  return (sevOrder[a.severity] || 0) - (sevOrder[b.severity] || 0);
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
  }, [reports, activeFilter, statusFilter, searchQuery, sortBy]);


  const handleChangeStatus = async (id, newStatus) => {
    setReports(prev => prev.map(r => r.id === id ? { ...r, status: newStatus } : r));
    try {
      const resp = await fetch(`${API_BASE}/admin/reports/${encodeURIComponent(id)}/status`, { method: 'PATCH', headers: buildHeaders(), credentials: 'include', body: JSON.stringify({ status: newStatus }) });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
    } catch { fetchReports(); }
  };


  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleteLoading(true);
    try {
      const resp = await fetch(`${API_BASE}/admin/reports/${encodeURIComponent(deleteTarget.id)}`, { method: 'DELETE', headers: buildHeaders(), credentials: 'include' });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      setReports(prev => prev.filter(r => r.id !== deleteTarget.id));
      setDeleteTarget(null);
    } catch { setErrorMsg('تعذر حذف البلاغ، حاول مرة أخرى.'); }
    finally { setDeleteLoading(false); }
  };


  const saveAction = async () => {
    if (!actionReport) return;
    setActionSaving(true); setActionError('');
    setReports(prev => prev.map(r => r.id === actionReport.id ? { ...r, status: actionStatus, notes: actionNote } : r));
    try {
      const resp = await fetch(`${API_BASE}/admin/reports/${encodeURIComponent(actionReport.id)}/action`, { method: 'PATCH', headers: buildHeaders(), credentials: 'include', body: JSON.stringify({ status: actionStatus, notes: actionNote }) });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      setActionReport(null);
    } catch { setActionError('حدث خطأ أثناء الحفظ، حاول مرة أخرى.'); fetchReports(); }
    finally { setActionSaving(false); }
  };


  const S = {
    page: {
      minHeight: '100vh', background: 'linear-gradient(0deg,rgba(255,255,255,.02),rgba(255,255,255,.02)),radial-gradient(92.12% 184.55% at 50% -55%,rgba(40,227,218,.16) 0%,rgba(40,227,218,0) 100%),#081423',
      display: 'flex', flexDirection: 'row', direction: 'rtl', color: '#fff',
    },
    main: { flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 },
    inner: {
      flex: 1,
      padding: isMobile ? '16px 12px 80px' : isTablet ? '20px 24px 24px' : '24px 48px 32px',
    },
    card: {
      background: 'radial-gradient(55% 100% at 50% -5%,rgba(40,227,218,.14) 0%,rgba(40,227,218,0) 60%),rgba(9,28,43,.9)',
      border: '1px solid rgba(40,227,218,.22)',
      borderRadius: '20px',
      boxShadow: '0 8px 32px rgba(0,0,0,.35)',
      backdropFilter: 'blur(6px)',
    },
    input: {
      background: 'rgba(8,20,35,.8)',
      border: '1px solid rgba(255,255,255,.12)',
      borderRadius: '12px',
      padding: '9px 14px',
      color: '#fff',
      fontSize: '13px',
      fontFamily: 'Alexandria,sans-serif',
      outline: 'none',
      width: '100%',
      boxSizing: 'border-box',
    },
    selectEl: {
      background: 'rgba(8,20,35,.85)',
      border: '1px solid rgba(255,255,255,.12)',
      borderRadius: '12px',
      padding: '8px 12px',
      color: '#fff',
      fontSize: '13px',
      fontFamily: 'Alexandria,sans-serif',
      outline: 'none',
      cursor: 'pointer',
    },
    label: { fontSize: '11px', color: '#64748b', fontFamily: 'Alexandria,sans-serif', marginBottom: '4px', display: 'block' },
    divider: { width: '100%', height: '1px', background: 'rgba(255,255,255,.07)', margin: '12px 0' },
  };


  return (
    <div style={S.page}>

      {             }
      <div className={isMobile ? '' : 'hidden md:block'} style={{ position: 'sticky', top: 0, height: '100vh', zIndex: 200, flexShrink: 0 }}>
        <Sidebar isOpen={isSidebarOpen} onClose={setIsSidebarOpen} />
      </div>

      {                                 }
      <div style={S.main}>
        <div style={S.inner}>

          {                        }
          <TopNav navigate={navigate} isMobile={isMobile} />

          {               }
          {errorMsg && (
            <div style={{ margin: '0 0 16px', padding: '12px 16px', borderRadius: '14px', background: 'rgba(251,191,36,.08)', border: '1px solid rgba(251,191,36,.3)', color: '#fde68a', fontSize: '13px', fontFamily: 'Alexandria,sans-serif' }}>
              ⚠ {errorMsg}
            </div>
          )}

          {                    }
          <StatsRow stats={stats} isMobile={isMobile} />

          {                  }
          <FiltersBar
            activeFilter={activeFilter} setActiveFilter={setActiveFilter}
            statusFilter={statusFilter} setStatusFilter={setStatusFilter}
            sortBy={sortBy}             setSortBy={setSortBy}
            searchQuery={searchQuery}   setSearchQuery={setSearchQuery}
            countsByCategory={countsByCategory}
            onRefresh={fetchReports}
            S={S}
          />

          {                    }
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', maxWidth: '900px', margin: '0 auto' }}>

            {loading && <LoadingState />}

            {!loading && filteredReports.length === 0 && <EmptyState />}

            {!loading && filteredReports.map(report => (
              <ReportCard
                key={report.id}
                report={report}
                S={S}
                onView={() => setSelectedReport(report)}
                onDelete={() => setDeleteTarget(report)}
                onAction={() => { setActionReport(report); setActionStatus(report.status || 'open'); setActionNote(report.notes || ''); setActionError(''); }}
                onChangeStatus={handleChangeStatus}
              />
            ))}

          </div>
        </div>

        <MobileBottomNav />
      </div>

      {                                  }
      {selectedReport && (
        <Modal onClose={() => setSelectedReport(null)}>
          <DetailsModal report={selectedReport} onClose={() => setSelectedReport(null)} />
        </Modal>
      )}

      {                                }
      {deleteTarget && (
        <Modal onClose={() => !deleteLoading && setDeleteTarget(null)}>
          <DeleteModal
            report={deleteTarget}
            loading={deleteLoading}
            onConfirm={confirmDelete}
            onCancel={() => setDeleteTarget(null)}
          />
        </Modal>
      )}

      {                                   }
      {actionReport && (
        <Modal onClose={() => !actionSaving && setActionReport(null)}>
          <ActionModal
            report={actionReport}
            actionStatus={actionStatus}  setActionStatus={setActionStatus}
            actionNote={actionNote}      setActionNote={setActionNote}
            actionSaving={actionSaving}
            actionError={actionError}
            onSave={saveAction}
            onClose={() => { if (!actionSaving) { setActionReport(null); setActionStatus(''); setActionNote(''); setActionError(''); } }}
          />
        </Modal>
      )}

    </div>
  );
};




function TopNav({ navigate, isMobile }) {
  const items = [
    { label: 'نظرة عامة',             path: '/dashboard'                },
    { label: 'إدارة المستخدمين',      path: '/user-management'          },
    { label: 'سجل النشاط',            path: '/activity-log'             },
    { label: 'الإبلاغات',             path: null, active: true          },
    { label: 'إضافة مقرر / محاضر',   path: '/add-course-lecturer'      },
    { label: 'إدارة المقررات',        path: '/manage-courses-lecturers' },
  ];
  return (
    <nav style={{
      display: 'flex', alignItems: 'center', justifyContent: isMobile ? 'flex-start' : 'space-evenly',
      flexWrap: 'wrap', gap: isMobile ? '6px' : '4px',
      padding: isMobile ? '10px 12px' : '0 16px',
      height: isMobile ? 'auto' : '52px',
      background: 'radial-gradient(43.64% 77.08% at 50% -10.42%,rgba(40,227,218,.2) 0%,rgba(40,227,218,0) 100%),rgba(9,28,43,.6)',
      border: '1px solid rgba(40,227,218,.2)',
      borderRadius: '16px',
      backdropFilter: 'blur(4px)',
      marginBottom: '24px',
    }}>
      {items.map((item, i) => (
        <React.Fragment key={item.label}>
          {i > 0 && !isMobile && <span style={{ color: 'rgba(255,255,255,.15)', fontSize: '18px', userSelect: 'none' }}>|</span>}
          <span
            onClick={() => item.path && navigate(item.path)}
            style={{
              fontFamily: 'Alexandria,sans-serif',
              fontSize: isMobile ? '12px' : '14px',
              fontWeight: item.active ? 800 : 500,
              color: item.active ? '#7DF9E8' : '#94a3b8',
              cursor: item.path ? 'pointer' : 'default',
              padding: isMobile ? '5px 10px' : '0 4px',
              borderRadius: isMobile ? '8px' : 0,
              background: item.active && isMobile ? 'rgba(40,227,218,.1)' : 'transparent',
              transition: 'color .15s',
              whiteSpace: 'nowrap',
            }}
            onMouseEnter={e => { if (item.path) e.target.style.color = '#fff'; }}
            onMouseLeave={e => { if (item.path) e.target.style.color = item.active ? '#7DF9E8' : '#94a3b8'; }}
          >
            {item.label}
          </span>
        </React.Fragment>
      ))}
    </nav>
  );
}




function StatsRow({ stats, isMobile }) {
  const cards = [
    { label: 'إجمالي البلاغات', value: stats.total,    icon: <IconFolder />,  color: '#28E3DA' },
    { label: 'بلاغات مفتوحة',  value: stats.open,     icon: <IconAlert />,   color: '#f87171' },
    { label: 'قيد المراجعة',   value: stats.inReview,  icon: <IconClock />,   color: '#fbbf24' },
    { label: 'تم إغلاقها',     value: stats.resolved,  icon: <IconCheck />,   color: '#34d399' },
  ];
  return (
    <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap: '12px', marginBottom: '20px' }}>
      {cards.map(c => (
        <div
          key={c.label}
          style={{
            background: 'radial-gradient(55% 90% at 50% -5%,rgba(40,227,218,.18) 0%,rgba(40,227,218,.04) 55%,rgba(8,20,35,.9) 100%)',
            border: '1px solid rgba(40,227,218,.22)',
            borderRadius: '18px',
            padding: '16px',
            display: 'flex', flexDirection: 'column', gap: '10px',
            transition: 'transform .2s,box-shadow .2s',
            boxShadow: '0 4px 20px rgba(0,0,0,.3)',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 12px 36px rgba(0,0,0,.45)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)';    e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,.3)'; }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ width: 34, height: 34, borderRadius: '10px', background: `${c.color}18`, border: `1px solid ${c.color}40`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: c.color }}>
              {c.icon}
            </div>
            <span style={{ fontSize: '12px', color: '#94a3b8', fontFamily: 'Alexandria,sans-serif' }}>{c.label}</span>
          </div>
          <span style={{ fontSize: '26px', fontWeight: 700, color: c.color, fontFamily: 'Alexandria,sans-serif', lineHeight: 1 }}>
            {c.value.toLocaleString('ar-SA')}
          </span>
        </div>
      ))}
    </div>
  );
}




function FiltersBar({ activeFilter, setActiveFilter, statusFilter, setStatusFilter, sortBy, setSortBy, searchQuery, setSearchQuery, countsByCategory, onRefresh, S }) {
  const tabs = [
    { key: 'lecturer', label: 'بلاغات المحاضرين' },
    { key: 'course',   label: 'بلاغات المقررات'  },
    { key: 'other',    label: 'بلاغات أخرى'       },
  ];
  return (
    <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {                   }
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {tabs.map(t => {
          const active = activeFilter === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setActiveFilter(t.key)}
              style={{
                padding: '8px 16px', borderRadius: '12px', cursor: 'pointer',
                fontFamily: 'Alexandria,sans-serif', fontSize: '13px', fontWeight: active ? 700 : 500,
                background: active ? 'linear-gradient(135deg,#28E3DA,#7DF9E8)' : 'rgba(255,255,255,.04)',
                color: active ? '#081423' : '#94a3b8',
                border: active ? '1px solid transparent' : '1px solid rgba(255,255,255,.1)',
                boxShadow: active ? '0 0 18px rgba(40,227,218,.4)' : 'none',
                transition: 'all .15s',
                display: 'flex', alignItems: 'center', gap: '6px',
              }}
            >
              {t.label}
              <span style={{
                minWidth: 20, height: 20, borderRadius: '999px', padding: '0 5px',
                background: active ? 'rgba(8,20,35,.25)' : 'rgba(255,255,255,.08)',
                color: active ? '#081423' : '#64748b',
                fontSize: '11px', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {countsByCategory[t.key]}
              </span>
            </button>
          );
        })}
      </div>

      {                       }
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
        {               }
        <div style={{ flex: '1 1 200px', position: 'relative', display: 'flex', alignItems: 'center' }}>
          <span style={{ position: 'absolute', right: '12px', color: '#475569', pointerEvents: 'none' }}><IconSearch /></span>
          <input
            type="text"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            placeholder="بحث باسم المُبلِّغ، البريد، المحاضر، أو نص البلاغ..."
            style={{ ...S.input, paddingRight: '36px' }}
          />
        </div>

        {                 }
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} style={S.selectEl}>
          <option value="all">كل الحالات</option>
          <option value="open">مفتوح</option>
          <option value="in_review">قيد المراجعة</option>
          <option value="resolved">مغلق</option>
        </select>

        {           }
        <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={S.selectEl}>
          <option value="newest">الأحدث أولاً</option>
          <option value="oldest">الأقدم أولاً</option>
          <option value="severity_high">الأعلى حساسية</option>
          <option value="severity_low">الأقل حساسية</option>
        </select>

        {           }
        <button
          onClick={onRefresh}
          title="تحديث البلاغات"
          style={{
            ...S.selectEl,
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '8px 14px', background: 'rgba(40,227,218,.08)',
            border: '1px solid rgba(40,227,218,.25)', color: '#7DF9E8',
          }}
        >
          <IconRefresh /> تحديث
        </button>
      </div>
    </div>
  );
}




function ReportCard({ report, S, onView, onDelete, onAction, onChangeStatus }) {
  const sm = STATUS_META[report.status]   || STATUS_META.open;
  const sv = SEVERITY_META[report.severity] || SEVERITY_META.medium;

  return (
    <div style={{ ...S.card, padding: '0', overflow: 'hidden' }}>

      {                                        }
      <div style={{ height: '3px', background: sm.color, opacity: 0.7 }} />

      <div style={{ padding: '18px 20px' }}>

        {                                           }
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px', flexWrap: 'wrap', gap: '8px' }}>
          {                    }
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
            <StatusBadge meta={sm} />
            <SeverityBadge meta={sv} />
            <span style={{ fontSize: '11px', color: '#475569', fontFamily: 'Alexandria,sans-serif', background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.08)', borderRadius: '8px', padding: '2px 8px' }}>
              {CATEGORY_LABEL[report.category] || report.category}
            </span>
          </div>
          {                              }
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
            <span style={{ fontFamily: 'monospace', fontSize: '12px', color: '#38bdf8', letterSpacing: '0.5px' }}>{report.id}</span>
            <span style={{ fontSize: '11px', color: '#475569', fontFamily: 'Alexandria,sans-serif' }}>{report.createdAtLabel || fmtDate(report.createdAt)}</span>
          </div>
        </div>

        {                                                       }
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
          {               }
          <div style={{ background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.07)', borderRadius: '12px', padding: '12px' }}>
            <div style={{ fontSize: '10px', color: '#475569', fontFamily: 'Alexandria,sans-serif', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>صاحب البلاغ</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '5px' }}>
              <span style={{ color: '#7DF9E8', flexShrink: 0 }}><IconUser /></span>
              <span style={{ fontSize: '13px', fontWeight: 600, color: '#e2e8f0', fontFamily: 'Alexandria,sans-serif', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{report.reporterName || '—'}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ color: '#475569', flexShrink: 0 }}><IconMail /></span>
              <span style={{ fontSize: '11px', color: '#64748b', fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{report.reporterEmail || '—'}</span>
            </div>
          </div>

          {                   }
          <div style={{ background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.07)', borderRadius: '12px', padding: '12px' }}>
            <div style={{ fontSize: '10px', color: '#475569', fontFamily: 'Alexandria,sans-serif', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              {report.category === 'lecturer' ? 'المُبلَّغ عنه' : report.category === 'course' ? 'المقرر المُبلَّغ عنه' : 'الجهة المعنية'}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '5px' }}>
              <span style={{ color: '#f87171', flexShrink: 0 }}><IconFlag /></span>
              <span style={{ fontSize: '13px', fontWeight: 600, color: '#e2e8f0', fontFamily: 'Alexandria,sans-serif', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{report.targetName || '—'}</span>
            </div>
            {report.targetType && (
              <span style={{ fontSize: '11px', color: '#64748b', fontFamily: 'Alexandria,sans-serif' }}>{report.targetType}</span>
            )}
          </div>
        </div>

        {                        }
        <div style={{ marginBottom: '10px' }}>
          <span style={{ fontSize: '11px', color: '#475569', fontFamily: 'Alexandria,sans-serif' }}>
            {report.category === 'lecturer' ? 'نوع الانتهاك' : report.category === 'course' ? 'نوع المشكلة' : 'الموضوع'}
          </span>
          <div style={{ fontSize: '14px', fontWeight: 600, color: '#f1f5f9', fontFamily: 'Alexandria,sans-serif', marginTop: '3px' }}>{report.title}</div>
        </div>

        {                       }
        {report.description && (
          <div style={{ fontSize: '12px', color: '#64748b', fontFamily: 'Alexandria,sans-serif', lineHeight: 1.7, marginBottom: '14px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
            {report.description}
          </div>
        )}

        {                                    }
        {report.notes && (
          <div style={{ fontSize: '11px', color: '#7DF9E8', fontFamily: 'Alexandria,sans-serif', background: 'rgba(40,227,218,.05)', border: '1px solid rgba(40,227,218,.15)', borderRadius: '8px', padding: '7px 10px', marginBottom: '14px' }}>
            📝 {report.notes}
          </div>
        )}

        <div style={{ width: '100%', height: '1px', background: 'rgba(255,255,255,.06)', margin: '4px 0 14px' }} />

        {                           }
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>

          {                         }
          <div style={{ display: 'flex', gap: '5px', flex: '1 1 auto', flexWrap: 'wrap' }}>
            {[
              { key: 'open',      label: 'مفتوح',         meta: STATUS_META.open      },
              { key: 'in_review', label: 'قيد المراجعة',  meta: STATUS_META.in_review },
              { key: 'resolved',  label: 'مغلق',           meta: STATUS_META.resolved  },
            ].map(s => {
              const isActive = report.status === s.key;
              return (
                <button
                  key={s.key}
                  onClick={() => onChangeStatus(report.id, s.key)}
                  style={{
                    padding: '5px 11px', borderRadius: '9px', cursor: 'pointer',
                    fontSize: '11px', fontFamily: 'Alexandria,sans-serif', fontWeight: isActive ? 700 : 400,
                    background: isActive ? s.meta.bg : 'rgba(255,255,255,.04)',
                    border: `1px solid ${isActive ? s.meta.border : 'rgba(255,255,255,.08)'}`,
                    color: isActive ? s.meta.color : '#64748b',
                    transition: 'all .15s',
                  }}
                >
                  {s.label}
                </button>
              );
            })}
          </div>

          {                              }
          <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
            <ActionBtn onClick={onView}   icon={<IconEye />}   label="تفاصيل"  color="#7DF9E8"   bgColor="rgba(40,227,218,.08)"  bdColor="rgba(40,227,218,.2)"  />
            <ActionBtn onClick={onAction} icon={<IconPen />}   label="إجراء"   color="#fbbf24"  bgColor="rgba(251,191,36,.08)" bdColor="rgba(251,191,36,.2)" />
            <ActionBtn onClick={onDelete} icon={<IconTrash />} label="حذف"     color="#f87171"  bgColor="rgba(248,113,113,.08)" bdColor="rgba(248,113,113,.2)" />
          </div>

        </div>
      </div>
    </div>
  );
}

function ActionBtn({ onClick, icon, label, color, bgColor, bdColor }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: '5px',
        padding: '6px 12px', borderRadius: '10px', cursor: 'pointer',
        fontSize: '12px', fontFamily: 'Alexandria,sans-serif', fontWeight: 600,
        background: bgColor, border: `1px solid ${bdColor}`, color,
        transition: 'all .15s',
      }}
      onMouseEnter={e => { e.currentTarget.style.opacity = '.8'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
    >
      {icon} {label}
    </button>
  );
}

function StatusBadge({ meta }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '3px 10px', borderRadius: '999px', fontSize: '11px', fontFamily: 'Alexandria,sans-serif', fontWeight: 600, background: meta.bg, border: `1px solid ${meta.border}`, color: meta.color }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: meta.color, flexShrink: 0 }} />
      {meta.label}
    </span>
  );
}

function SeverityBadge({ meta }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', padding: '3px 10px', borderRadius: '999px', fontSize: '11px', fontFamily: 'Alexandria,sans-serif', background: meta.bg, border: `1px solid ${meta.border}`, color: meta.color }}>
      ◈ {meta.label}
    </span>
  );
}




function LoadingState() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '14px', padding: '60px 20px', background: 'rgba(9,28,43,.5)', borderRadius: '20px', border: '1px solid rgba(40,227,218,.1)' }}>
      <div style={{ width: 36, height: 36, border: '3px solid rgba(40,227,218,.15)', borderTopColor: '#28E3DA', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      <span style={{ fontSize: '13px', color: '#475569', fontFamily: 'Alexandria,sans-serif' }}>جاري تحميل البلاغات...</span>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

function EmptyState() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '60px 20px', background: 'rgba(9,28,43,.4)', borderRadius: '20px', border: '1px dashed rgba(255,255,255,.1)' }}>
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ color: '#334155', opacity: .6 }}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>
      <span style={{ fontSize: '14px', color: '#475569', fontFamily: 'Alexandria,sans-serif' }}>لا توجد بلاغات مطابقة للفلتر الحالي</span>
    </div>
  );
}




function Modal({ children, onClose }) {
  return (
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,.7)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', direction: 'rtl' }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      {children}
    </div>
  );
}




function DetailsModal({ report, onClose }) {
  const sm = STATUS_META[report.status]    || STATUS_META.open;
  const sv = SEVERITY_META[report.severity] || SEVERITY_META.medium;
  const Field = ({ label, value, mono }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <span style={{ fontSize: '11px', color: '#475569', fontFamily: 'Alexandria,sans-serif' }}>{label}</span>
      <span style={{ fontSize: '13px', color: '#e2e8f0', fontFamily: mono ? 'monospace' : 'Alexandria,sans-serif', wordBreak: 'break-word' }}>{value || '—'}</span>
    </div>
  );

  return (
    <div style={{
      width: '100%', maxWidth: '600px', maxHeight: '90vh', overflow: 'hidden',
      background: 'radial-gradient(55% 80% at 50% -5%,rgba(40,227,218,.12) 0%,rgba(8,20,35,.99) 65%),#050c17',
      border: '1px solid rgba(40,227,218,.25)', borderRadius: '24px',
      boxShadow: '0 30px 80px rgba(0,0,0,.8)',
      display: 'flex', flexDirection: 'column',
    }}>
      {            }
      <div style={{ padding: '18px 20px', borderBottom: '1px solid rgba(255,255,255,.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#475569', padding: '4px', borderRadius: '8px', display: 'flex' }}>
          <IconClose />
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <h2 style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: '#f1f5f9', fontFamily: 'Alexandria,sans-serif' }}>تفاصيل البلاغ</h2>
          <span style={{ fontFamily: 'monospace', fontSize: '12px', color: '#38bdf8', background: 'rgba(56,189,248,.08)', border: '1px solid rgba(56,189,248,.2)', borderRadius: '8px', padding: '2px 8px' }}>{report.id}</span>
        </div>
      </div>

      {          }
      <div style={{ flex: 1, overflowY: 'auto', padding: '18px 20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

        {            }
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <StatusBadge meta={sm} />
          <SeverityBadge meta={sv} />
          <span style={{ fontSize: '11px', color: '#64748b', fontFamily: 'Alexandria,sans-serif', background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.08)', borderRadius: '999px', padding: '3px 10px' }}>
            {CATEGORY_LABEL[report.category] || report.category}
          </span>
        </div>

        {                   }
        <Section title="معلومات المُبلِّغ" color="#7DF9E8">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <Field label="الاسم"            value={report.reporterName} />
            <Field label="البريد الإلكتروني" value={report.reporterEmail} mono />
          </div>
        </Section>

        {                       }
        <Section title={report.category === 'lecturer' ? 'المُبلَّغ عنه' : report.category === 'course' ? 'المقرر' : 'الجهة المعنية'} color="#f87171">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <Field label="الاسم / المسمى" value={report.targetName} />
            <Field label="النوع"           value={report.targetType} />
          </div>
        </Section>

        {                }
        <Section title="تفاصيل البلاغ" color="#fbbf24">
          <Field label={report.category === 'lecturer' ? 'نوع الانتهاك' : 'موضوع المشكلة'} value={report.title} />
          <div style={{ height: '8px' }} />
          <div style={{ fontSize: '11px', color: '#475569', fontFamily: 'Alexandria,sans-serif', marginBottom: '5px' }}>الوصف التفصيلي</div>
          <div style={{ fontSize: '13px', color: '#cbd5e1', fontFamily: 'Alexandria,sans-serif', lineHeight: 1.8, whiteSpace: 'pre-wrap', background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.06)', borderRadius: '10px', padding: '12px' }}>
            {report.description || '—'}
          </div>
        </Section>

        {               }
        <Section title="معلومات إضافية" color="#60a5fa">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <Field label="وقت الإرسال"   value={fmtDate(report.createdAt)} />
            <Field label="صفحة المصدر"   value={report.source} />
            <Field label="عنصر مرتبط"   value={report.relatedEntity} />
            <Field label="آخر تحديث"     value={report.updatedAt ? fmtDate(report.updatedAt) : '—'} />
          </div>
        </Section>

        {                    }
        {report.notes && (
          <Section title="الإجراء المتخذ (داخلي)" color="#34d399">
            <div style={{ fontSize: '13px', color: '#a7f3d0', fontFamily: 'Alexandria,sans-serif', lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>
              {report.notes}
            </div>
          </Section>
        )}

      </div>

      {            }
      <div style={{ padding: '14px 20px', borderTop: '1px solid rgba(255,255,255,.07)', display: 'flex', justifyContent: 'flex-start' }}>
        <button
          onClick={onClose}
          style={{ padding: '9px 20px', borderRadius: '12px', cursor: 'pointer', background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,255,255,.12)', color: '#e2e8f0', fontSize: '13px', fontFamily: 'Alexandria,sans-serif' }}
        >
          إغلاق
        </button>
      </div>
    </div>
  );
}

function Section({ title, color, children }) {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
        <div style={{ width: 3, height: 16, borderRadius: '2px', background: color, flexShrink: 0 }} />
        <span style={{ fontSize: '12px', fontWeight: 700, color, fontFamily: 'Alexandria,sans-serif', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{title}</span>
      </div>
      {children}
    </div>
  );
}




function DeleteModal({ report, loading, onConfirm, onCancel }) {
  return (
    <div style={{
      width: '100%', maxWidth: '420px',
      background: 'radial-gradient(60% 80% at 50% 0%,rgba(248,113,113,.12) 0%,rgba(8,20,35,.99) 65%),#050c17',
      border: '1px solid rgba(248,113,113,.3)', borderRadius: '24px',
      boxShadow: '0 30px 80px rgba(0,0,0,.8)', padding: '24px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
        <button onClick={onCancel} disabled={loading} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#475569', display: 'flex' }}><IconClose /></button>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <h2 style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: '#fca5a5', fontFamily: 'Alexandria,sans-serif' }}>تأكيد الحذف</h2>
          <div style={{ width: 36, height: 36, borderRadius: '10px', background: 'rgba(248,113,113,.12)', border: '1px solid rgba(248,113,113,.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#f87171' }}>
            <IconTrash />
          </div>
        </div>
      </div>

      <div style={{ fontSize: '13px', color: '#94a3b8', fontFamily: 'Alexandria,sans-serif', lineHeight: 1.8, marginBottom: '20px' }}>
        هل أنت متأكد من حذف البلاغ{' '}
        <span style={{ color: '#fca5a5', fontFamily: 'monospace', background: 'rgba(248,113,113,.1)', padding: '1px 6px', borderRadius: '5px' }}>{report.id}</span>
        {' '}؟ لا يمكن التراجع عن هذا الإجراء.
      </div>

      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-start' }}>
        <button
          onClick={onConfirm}
          disabled={loading}
          style={{ padding: '9px 20px', borderRadius: '12px', cursor: loading ? 'not-allowed' : 'pointer', background: 'rgba(220,38,38,.9)', border: 'none', color: '#fff', fontSize: '13px', fontWeight: 700, fontFamily: 'Alexandria,sans-serif', opacity: loading ? .6 : 1 }}
        >
          {loading ? 'جاري الحذف...' : 'تأكيد الحذف'}
        </button>
        <button
          onClick={onCancel}
          disabled={loading}
          style={{ padding: '9px 20px', borderRadius: '12px', cursor: 'pointer', background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,255,255,.12)', color: '#e2e8f0', fontSize: '13px', fontFamily: 'Alexandria,sans-serif', opacity: loading ? .5 : 1 }}
        >
          إلغاء
        </button>
      </div>
    </div>
  );
}




function ActionModal({ report, actionStatus, setActionStatus, actionNote, setActionNote, actionSaving, actionError, onSave, onClose }) {
  const inputStyle = {
    width: '100%', boxSizing: 'border-box',
    background: 'rgba(8,20,35,.85)',
    border: '1px solid rgba(255,255,255,.12)',
    borderRadius: '12px', padding: '10px 14px',
    color: '#fff', fontSize: '13px', fontFamily: 'Alexandria,sans-serif', outline: 'none',
  };

  return (
    <div style={{
      width: '100%', maxWidth: '540px', maxHeight: '90vh', overflow: 'hidden',
      background: 'radial-gradient(55% 80% at 50% -5%,rgba(40,227,218,.1) 0%,rgba(8,20,35,.99) 65%),#050c17',
      border: '1px solid rgba(40,227,218,.25)', borderRadius: '24px',
      boxShadow: '0 30px 80px rgba(0,0,0,.8)', display: 'flex', flexDirection: 'column',
    }}>
      {            }
      <div style={{ padding: '18px 20px', borderBottom: '1px solid rgba(255,255,255,.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#475569', display: 'flex' }}><IconClose /></button>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <h2 style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: '#f1f5f9', fontFamily: 'Alexandria,sans-serif' }}>تسجيل الإجراء</h2>
          <div style={{ width: 36, height: 36, borderRadius: '10px', background: 'rgba(40,227,218,.1)', border: '1px solid rgba(40,227,218,.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#7DF9E8' }}>
            <IconPen />
          </div>
        </div>
      </div>

      {          }
      <div style={{ flex: 1, overflowY: 'auto', padding: '18px 20px', display: 'flex', flexDirection: 'column', gap: '14px' }}>

        {                    }
        <div style={{ background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.07)', borderRadius: '12px', padding: '12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span style={{ fontSize: '11px', color: '#475569', fontFamily: 'Alexandria,sans-serif' }}>البلاغ المحدد</span>
          <span style={{ fontSize: '13px', color: '#38bdf8', fontFamily: 'monospace' }}>{report.id}</span>
          <span style={{ fontSize: '13px', color: '#e2e8f0', fontFamily: 'Alexandria,sans-serif' }}>{report.title}</span>
          <span style={{ fontSize: '12px', color: '#64748b', fontFamily: 'Alexandria,sans-serif' }}>{report.reporterName} — {report.reporterEmail}</span>
        </div>

        {                    }
        <div>
          <label style={{ display: 'block', fontSize: '12px', color: '#64748b', fontFamily: 'Alexandria,sans-serif', marginBottom: '6px' }}>تغيير الحالة إلى</label>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '6px' }}>
            {[
              { key: 'open',      meta: STATUS_META.open,      label: 'مفتوح'         },
              { key: 'in_review', meta: STATUS_META.in_review,  label: 'قيد المراجعة'  },
              { key: 'resolved',  meta: STATUS_META.resolved,   label: 'مغلق'          },
            ].map(s => {
              const active = actionStatus === s.key;
              return (
                <button
                  key={s.key}
                  onClick={() => setActionStatus(s.key)}
                  style={{
                    padding: '8px 6px', borderRadius: '10px', cursor: 'pointer',
                    fontFamily: 'Alexandria,sans-serif', fontSize: '12px', fontWeight: active ? 700 : 400,
                    background: active ? s.meta.bg : 'rgba(255,255,255,.03)',
                    border: `1px solid ${active ? s.meta.border : 'rgba(255,255,255,.08)'}`,
                    color: active ? s.meta.color : '#64748b',
                    transition: 'all .15s',
                  }}
                >
                  {s.label}
                </button>
              );
            })}
          </div>
        </div>

        {             }
        <div>
          <label style={{ display: 'block', fontSize: '12px', color: '#64748b', fontFamily: 'Alexandria,sans-serif', marginBottom: '6px' }}>
            وصف الإجراء المتخذ
            <span style={{ color: '#334155', marginRight: '6px' }}>مثال: "تم التواصل مع المحاضر" / "تم تحويل البلاغ"</span>
          </label>
          <textarea
            value={actionNote}
            onChange={e => setActionNote(e.target.value)}
            rows={5}
            placeholder="اكتب هنا الإجراء الذي تم اتخاذه على هذا البلاغ..."
            style={{ ...inputStyle, resize: 'vertical', lineHeight: 1.7 }}
            onFocus={e  => { e.target.style.borderColor = 'rgba(40,227,218,.45)'; }}
            onBlur={e   => { e.target.style.borderColor = 'rgba(255,255,255,.12)'; }}
          />
        </div>

        {actionError && (
          <div style={{ padding: '10px 14px', borderRadius: '10px', background: 'rgba(248,113,113,.08)', border: '1px solid rgba(248,113,113,.25)', color: '#fca5a5', fontSize: '12px', fontFamily: 'Alexandria,sans-serif' }}>
            {actionError}
          </div>
        )}
      </div>

      {            }
      <div style={{ padding: '14px 20px', borderTop: '1px solid rgba(255,255,255,.07)', display: 'flex', gap: '8px', justifyContent: 'flex-start' }}>
        <button
          onClick={onSave}
          disabled={actionSaving}
          style={{ padding: '9px 22px', borderRadius: '12px', cursor: actionSaving ? 'not-allowed' : 'pointer', background: 'linear-gradient(135deg,#28E3DA,#7DF9E8)', border: 'none', color: '#081423', fontSize: '13px', fontWeight: 700, fontFamily: 'Alexandria,sans-serif', opacity: actionSaving ? .6 : 1, boxShadow: actionSaving ? 'none' : '0 4px 16px rgba(40,227,218,.3)' }}
        >
          {actionSaving ? 'جاري الحفظ...' : 'حفظ الإجراء'}
        </button>
        <button
          onClick={onClose}
          disabled={actionSaving}
          style={{ padding: '9px 18px', borderRadius: '12px', cursor: 'pointer', background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,255,255,.12)', color: '#e2e8f0', fontSize: '13px', fontFamily: 'Alexandria,sans-serif', opacity: actionSaving ? .5 : 1 }}
        >
          إلغاء
        </button>
      </div>
    </div>
  );
}

export default ReportsPage;
